/**
 * Actions commerciales proactives sur les clients récurrents.
 * 28/07/2026 — retour user prod : « j'ai un ranking mais je ne peux pas
 * faire d'actions […] ce serait bien d'avoir une petite série de leviers
 * d'actions pour devenir proactif sur des missions auprès de certains
 * clients. »
 *
 * Ajustements user :
 *   - « Solliciter une mission » PEUT générer une mission ponctuelle,
 *     pas garanti (probabilité liée à la fidélité).
 *   - « Plan de reconquête » : focus commercial complet sur une relation
 *     dégradée (audit qualité + geste commercial + chauffeur attitré),
 *     pas une simple remise.
 */

export const CLIENT_ACTIONS = [
  {
    id: 'visite-commerciale',
    label: 'Visite commerciale',
    cost: 800,
    cooldownDays: 45,
    description: 'Déjeuner et visite du site client pour entretenir la relation. +6 fidélité.',
  },
  {
    id: 'invitation-evenement',
    label: 'Invitation événement',
    cost: 1800,
    cooldownDays: 90,
    description: 'Invitez le décideur à un salon professionnel. +8 fidélité, +1 notoriété.',
  },
  {
    id: 'solliciter-mission',
    label: 'Solliciter une mission',
    cost: 0,
    cooldownDays: 60,
    minScore: 40, // au moins « Confiant »
    description: 'Demandez un flux dédié. Chance de succès selon la fidélité — peut générer un contrat ponctuel réservé sur le tableau des contrats (non garanti).',
  },
  {
    id: 'plan-reconquete',
    label: 'Plan de reconquête',
    cost: 2500,
    cooldownDays: 120,
    maxScore: 40, // relation dégradée uniquement (Méfiant / Neutre)
    description: 'Focus commercial complet : audit qualité, geste commercial, chauffeur attitré. +13 fidélité et lève un éventuel gel « Méfiant ».',
  },
];

export const CLIENT_ACTION_BY_ID = CLIENT_ACTIONS.reduce((acc, a) => {
  acc[a.id] = a; return acc;
}, {});

/** Probabilité qu'une sollicitation de mission aboutisse (score 40 → 45 %, 85 → ~67 %, plafond 75 %). */
export function missionRequestChance(score) {
  return Math.min(0.75, 0.25 + Math.max(0, score || 0) / 200);
}
